import { render, staticRenderFns } from "./consultfiedButton.vue?vue&type=template&id=6e271ea2&scoped=true&"
import script from "./consultfiedButton.vue?vue&type=script&lang=js&"
export * from "./consultfiedButton.vue?vue&type=script&lang=js&"
import style0 from "./consultfiedButton.vue?vue&type=style&index=0&id=6e271ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e271ea2",
  null
  
)

export default component.exports